import React from "react";
import PropTypes from "prop-types";

export default function FeelingsWheel({ className, ...delegated }) {
  return (
    <svg
      viewBox="0 0 40 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...delegated}
    >
      <circle cx="20.0005" cy="6.84036" r="6.84036" fill="#5D15E3" />
      <circle cx="20.0005" cy="36.0669" r="6.84036" fill="#FC125F" />
      <circle cx="7.34426" cy="14.1475" r="6.84036" fill="#FFE700" />
      <circle cx="32.6558" cy="28.7608" r="6.84036" fill="#00CF91" />
      <circle cx="7.34402" cy="28.7613" r="6.84036" fill="#FFB81C" />
      <circle cx="32.6555" cy="14.147" r="6.84036" fill="#147BD1" />
    </svg>
  );
}

FeelingsWheel.propTypes = {
  className: PropTypes.string,
};
